<template>
  <div id="clip-add-reading" :class="modelClass" tabindex="-1" role="dialog">
    <div class="clip-share modal-dialog">
      <!-- Modal content-->
      <input type="hidden" id="add-clip-id" :value="id" />
      <div class="clip-share modal-content">
        <div class="clip-share modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="closeModal"
          >
            <i class="fa fa-times"></i>
          </button>
          <div class="add-to-clip modal-title text-center">
            <h3 class="text-capitalize">Add to {{ trans("book.singular") }}</h3>
            <p v-if="successMessage == false">
              Add
              <a href>“{{ clipName }}”</a>
              to one of your {{ trans("book.multiple") }} below:
            </p>
            <p v-if="successMessage == true">
              “{{ clip }}” has been added to the “{{ bookName }}”
            </p>
          </div>
        </div>
        <div class="clip-add-reading modal-body" v-if="successMessage == false">
          <div class="listing-view">
            <div class="clip-list" v-for="book in bookList" :key="book.id">
              <span class="custom-radio pull-right">
                <input
                  type="radio"
                  class
                  name="book"
                  :id="book.id"
                  :value="book.id"
                  v-model="bookId"
                  @click="getSections(book.slug)"
                />
              </span>
              <label :for="book.id">
                {{ book.title }}
                <p
                  v-if="book.user && book.user.user_type === '0'"
                  class="text-normal"
                >
                  contributed by
                  {{ book.user.first_name }}
                </p>
                <p v-else class="text-normal">
                  contributed by
                  {{ book.user.first_name + " " + book.user.last_name }}
                </p>
              </label>
            </div>
            <div id class="clip-list redirect-to-book">
              <div class="form-item form-type-radio form-item-haggadah">
                <label class="option">
                  <span>
                    <p>Add To New {{ trans("book.Singular") }}</p>
                    <div class="description">
                      Add this {{ trans("clip.singular") }} to a new
                      {{ trans("book.singular") }}.
                    </div>
                  </span>
                  <span class="right-sign">
                    <i class="fa fa-angle-right"></i>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <br />
          <div class="clip-add-section">
            <hr />
            <div v-if="error.book" class="has-error text-danger">
              <strong>{{ error.book }}</strong>
            </div>
            <div class="row">
              <div class="col-lg-8">
                <div class="form-group">
                  <label for="section_id" class="control-label text-capitalize"
                    >{{ trans("book.Singular") }} Sections:</label
                  >
                  <chosen-select
                    ref="sectionChosen"
                    @input="setSection"
                    :value="this.sectionName"
                    style="width: 100%"
                  >
                    <option
                      v-for="(item, index) in book_sections"
                      :key="index"
                      :value="item"
                    >
                      {{ item }}
                    </option>
                  </chosen-select>
                </div>
              </div>
              <div class="col-lg-4 clip-section-btn">
                <!-- <a
                  class="colorWhite brandon_grotesque_medium btn-font-big btn btn-md btn-lg btn-cancel"
                  @click.prevent="closeModal"
                >CANCEL</a>-->
                <a
                  id="anchor_add_to_book_jhn"
                  class="
                    colorWhite
                    brandon_grotesque_medium
                    btn-font-big btn btn-md btn-lg btn-primary-color
                    text-uppercase
                  "
                  @click.prevent="addCliptoBook"
                  >ADD {{ trans("clip.singular") }}</a
                >
                <div v-if="busy === true" class="loader-ajax"></div>
                <div id="loader-ajax-jhn-clone" class="loader-ajax hide"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body" v-if="successMessage == true">
          <!-- <spa“{{ clip }}” has been added to the “{{ bookName }}” -->
          <div class="clip-add-section">
            <!-- <hr> -->
            <div class="row">
              <div class="text-center">
                <a
                  class="
                    brandon_grotesque_medium
                    btn-font-big btn btn-lg btn-md btn-cancel
                    text-uppercase
                  "
                  @click.prevent="closeModal"
                  >CLOSE</a
                >
                <!--  <a :href="'#'+slug(section)" class="smoth-scroll"> {{ section }}<span class="cnt">({{ sectionWithCounter(section_key) }})</span> </a> -->

                <a
                  :href="
                    this.route('user.book.edit', { slug: bookSlug }) +
                    this.getSectionName()
                  "
                  class="
                    colorWhite
                    brandon_grotesque_medium
                    btn-font-big btn btn-lg btn-md btn-primary-color
                    text-uppercase
                  "
                >
                  VIEW {{ trans("clip.singular") }} IN
                  {{ trans("book.singular") }}
                  <i class="fa fa-long-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isFade", "id", "bookList", "clipName", "sectionList"],
  data: function () {
    return {
      bookId: "",
      bookSlug: "",
      successMessage: false,
      clip: "",
      bookName: "",
      busy: false,
      error: {},
      section_id: this.$root.sectionID,
      sectionName: this.$root.sectionName,
      book_sections: [],
      book_section_details: [],
    };
  },

  mounted() {},

  computed: {
    modelClass() {
      return ["modal", "fade", this.isFade ? "in" : ""];
    },
  },

  methods: {
    getSectionName() {
      if (this.section_id in this.book_section_details) {
        var sectionSlug =
          this.book_section_details[this.section_id]["clip_type"]["slug"];
        return "#" + sectionSlug;
      }
      return "";
    },
    closeModal() {
      this.$emit("closed", false);
    },
    setSection(section) {
      let vm = this;
      let section_id = "";
      $.each(vm.book_sections, function (index, val) {
        if (val === section) {
          section_id = index;
        }
      });
      vm.section_id = section_id;
    },
    addCliptoBook() {
      let vm = this;
      var section_id = this.section_id;
      var clip_id = vm.id;
      // console.log(clip_id);
      var data = {};
      data["" + section_id] = { 0: clip_id };
      this.busy = true;
      if (!this.bookId) {
        this.error["book"] = "Please select " + this.trans("book.singular");
        this.busy = false;
      } else {
        axios
          .post(this.route("user.book.updateClipList", { id: this.bookId }), {
            clip_list: data,
            clip_name: this.clipName,
          })
          .then(({ data }) => {
            $.each(data, function (index, clip) {
              if (vm.id === clip.id) {
                vm.clip = clip.title;
              } else {
                vm.clip = "clip";
              }
            });
            $.each(vm.bookList, function (index, book) {
              if (vm.bookId === book.id) {
                vm.bookName = book.title;
                vm.bookSlug = book.slug;
              }
            });
            $(".clip-add-reading").remove();
            this.successMessage = true;
            this.busy = false;

            // console.log(data);
          });
      }
    },
    getSections(slug) {
      let vm = this;
      axios
        .get(this.route("user.book.section", { slug: slug }))
        .then(({ data }) => {
          vm.book_sections = {};
          vm.book_section_details = {};
          for (var section_details of data) {
            // console.log(section_details);
            vm.book_sections[`${section_details["id"]}`] =
              section_details["clip_type"]["name"];
            vm.book_section_details[`${section_details["id"]}`] =
              section_details;
          }
          this.$nextTick(function () {
            vm.$refs.sectionChosen.update(vm.book_section);
          });
        });
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }
          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        // add Event Listeners
        document.addEventListener("click", handler);
      },
      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};
$(document).on("click", ".clip-add-reading input[type=radio]", function () {
  if ($(this).is(":checked")) {
    $(".clip-list").removeClass("checked");
    $(this).parents(".clip-list").addClass("checked");
  } else {
    $(this).parents(".clip-list").removeClass("checked");
  }
});
</script>